module.exports = __webpack_public_path__ + "img/jcsteeleservice-brushed-logo.b2b185f9.png";